import React, {useContext} from 'react';

export type RenderContext = 'productPage' | 'stickyDrawer';

export const RenderContextContext = React.createContext<RenderContext>('productPage');

export const useRenderContext = () => useContext(RenderContextContext);
export const RenderContextProvider = RenderContextContext.Provider;

export function useIsRenderedFrom(context: RenderContext): boolean {
  return useRenderContext() === context;
}

export type WithRenderContextProps = {
  renderContext?: RenderContext;
};

export function withRenderContext<P extends WithRenderContextProps>(
  Component: React.ComponentType<P>
): React.ComponentType<Omit<P, 'renderContext'>> {
  return (props: Omit<P, 'renderContext'>) => {
    const renderContext = useRenderContext();
    return <Component {...(props as P)} renderContext={renderContext} />;
  };
}
